module.exports = __webpack_public_path__ + "img/errorallocate.767e9e72.svg";